import { styled } from '@mui/system';
import {
    Box,
    Typography,
    TextField,
    Select,
    Button,
    Chip
} from '@mui/material';
import theme from 'src/theme';

export const SectionTitle = styled(Typography)({
    color: theme.color.white,
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: 600,
    marginBottom: '8px',
    opacity: 0.7
});

export const ChipsContainer = styled(Box)({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    marginBottom: '12px'
});

export const ExpenseChip = styled(Chip)({
    backgroundColor: theme.color.white10,
    color: theme.color.white,
    fontFamily: 'Inter',
    fontSize: '12px',
    '& .MuiChip-deleteIcon': {
        color: theme.color.white,
        fontSize: 14
    },
    '& .MuiChip-deleteIcon:hover': {
        color: theme.color.lightningYellow
    }
});

export const FormRow = styled(Box)({
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
});

export const ProviderSelect = styled(Select)({
    minWidth: 90,
    color: theme.color.white,
    fontFamily: 'Inter',
    fontSize: '12px',
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.color.white30
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.color.white50
    },
    '& .MuiSvgIcon-root': {
        color: theme.color.white50
    }
});

export const AccountIdInput = styled(TextField)({
    flex: 1,
    maxWidth: 220,
    '& .MuiInputBase-input': {
        color: theme.color.white,
        fontFamily: 'Inter',
        fontSize: '12px',
        padding: '8px 12px'
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.color.white30
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.color.white50
    }
});

export const AddButton = styled(Button)({
    color: theme.color.darkBlue,
    backgroundColor: theme.color.lightningYellow,
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 600,
    textTransform: 'none',
    paddingLeft: '16px',
    paddingRight: '16px',
    '&:hover': {
        backgroundColor: theme.color.goldenColor
    },
    '&.Mui-disabled': {
        backgroundColor: theme.color.white10,
        color: theme.color.white30
    }
});

export const Container = styled(Box)({
    marginTop: '16px',
    marginBottom: '8px'
});
